import { render } from "./DeathView.vue?vue&type=template&id=68ad5b3e"
import script from "./DeathView.vue?vue&type=script&lang=js"
export * from "./DeathView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__